module.exports = "/packs/media/modules/startups/quality-check/components/QualityCheck/images/exampleJuiceSideLeft-7711f1da2d5689268dbd8b8b720cb28d.png";